<template>
  <vs-row vs-type="block" vs-w="12" id="dashBoardProductReport" class="py-1">
    <branch-product-report-viewer @getExcel="getExcelPersonalReportAccordingTo"  @openVariantPopup="openVariantPopup" ref="branchProductReportViewer"
                                  :report="selectedProduct" @close="selectedProduct = {}"/>
                                  <variant-popup :variantPopup="variantPopup" :variantSums="variantSums" @close="variantPopup=false" ref="variantPopup"/>
    <span v-if="!stop" class="text-xsmall text-secondary bold">
      Ürün Bazlı Ciro Raporu
    </span>
    <vs-row vs-type="flex" vs-w="12" id="productReportFilter" class="my-2" v-if="stop">
      <vs-input v-model="filterString" class="w-full border-radius border-all" placeholder="Ürün Arama"/>
    </vs-row>
    <vs-row class="weight-600 text-smaller border-bottom border-secondary py-1">
      <vs-col :vs-w="showBranch ? 3 : 5" vs-type="flex" vs-justify="start">
        <span>
          İsim
        </span>
      </vs-col>
      <vs-col vs-w="2" vs-type="flex" vs-justify="start" v-if="showBranch">
        <span>
          Şube
        </span>
      </vs-col>
      <vs-col vs-w="1" vs-type="flex" vs-justify="center">
        <span>
          Adet
        </span>
      </vs-col>
      <vs-col vs-w="2" vs-type="flex" vs-justify="center">
        <span>
          Ciro
        </span>
      </vs-col>
      <vs-col vs-w="2" vs-type="flex" vs-justify="center">
        <span>
          Maaliyet
        </span>
      </vs-col>
      <vs-col vs-w="2" vs-type="flex" vs-justify="center">
        <span>
          Kar
        </span>
      </vs-col>
    </vs-row>
    <vs-row vs-type="flex" vs-w="12" class="py-1" vs-justify="space-between"
            v-for="(product,index) in (filteredList && filteredList.length > 0 ? filteredList : [])" :key="index">
      <div @click="getPersonalReportAccordingTo(product)"
           class="d-flex w-full text-xsmall justify-between cursor-pointer border-bottom border-secondary py-1">
        <vs-col vs-type="flex" :vs-w="showBranch ? 3 : 5" vs-align="center">
          <span class="text-primary mr-2 text-xsmall weight-600">
            {{ (index + 1) + '.' }}
          </span>
          <span class="text-primary text-xsmall weight-600">
            {{ product.typeValue }}
          </span>
        </vs-col>
        <vs-col vs-type="flex" vs-w="2" vs-align="center" v-if="showBranch">
          <span class="text-secondary weight-600 text-xsmall">
            {{ product.branchName || 'Tümü' }}
          </span>
        </vs-col>
        <vs-col vs-type="flex" vs-w="1" vs-align="center">
          <span :class="{'text-primary text-smaller' : orderBy == 1}"
                class="text-secondary weight-600 w-full text-center">
            {{ product.piece.toLocaleString() }}
          </span>
        </vs-col>
        <vs-col vs-type="flex" vs-w="2" vs-align="center">
          <span :class="{'text-primary text-smaller' : orderBy == 0}"
                class="text-secondary weight-600 w-full text-center">
            {{ $convertCurrency(product.amount) }}
          </span>
        </vs-col>
        <vs-col vs-type="flex" vs-w="2" vs-align="center">
          <span :class="{'text-primary text-smaller' : orderBy == 2}"
                class="text-secondary weight-600 w-full text-center">
            {{ $convertCurrency(product.cost) }}
          </span>
        </vs-col>
        <vs-col vs-type="flex" vs-w="2" vs-align="center">
          <span :class="{'text-primary text-smaller' : orderBy == 3}"
                class="text-secondary weight-600 w-full text-center">
            {{ $convertCurrency(product.profit) }}
          </span>
        </vs-col>
      </div>
    </vs-row>
    <vs-row v-if="!stop" vs-type="flex" vs-w="12" class="pt-3 pb-1" vs-justify="center" vs-align="center">
      <span @click="openDetailPage" class="text-secondary text-xsmaller bold underline cursor-pointer">
        Detay Sayfasına Git
      </span>
    </vs-row>
    <vs-row v-if="stop && paymentPositiveTotal != null && paymentPositiveTotal !== undefined" vs-type="flex" vs-w="12" class="py-1 border-bottom border-secondary text-secondary text-xsmall" vs-align="center">
      <vs-col vs-type="flex" :vs-w="showBranch ? 3 : 5" vs-align="center">
        <span class="text-dark weight-600">Toplam Ciro (ödemeler, pozitif)</span>
      </vs-col>
      <vs-col vs-type="flex" vs-w="2" vs-align="center" vs-justify="center" v-if="showBranch">
        <span class="text-secondary">—</span>
      </vs-col>
      <vs-col vs-type="flex" vs-w="1" vs-align="center" vs-justify="center">
        <span class="text-secondary">—</span>
      </vs-col>
      <vs-col vs-type="flex" vs-w="2" vs-align="center" vs-justify="center">
        <span class="text-primary bold">
          {{ $convertCurrency(paymentPositiveTotal) }}
        </span>
      </vs-col>
      <vs-col vs-type="flex" vs-w="2" vs-align="center" vs-justify="center">
        <span class="text-secondary">—</span>
      </vs-col>
      <vs-col vs-type="flex" vs-w="2" vs-align="center" vs-justify="center">
        <span class="text-secondary">—</span>
      </vs-col>
    </vs-row>
    <vs-row v-if="stop" vs-type="flex" vs-w="12" class="py-1 border-bottom border-secondary text-secondary text-smaller" vs-align="center">
      <vs-col vs-type="flex" :vs-w="showBranch ? 3 : 5" vs-align="center">
        <span class="text-dark text-smaller bold">
        Toplam
        </span>
      </vs-col>
      <vs-col vs-type="flex" vs-w="2" vs-align="center" vs-justify="center" v-if="showBranch">
        <span class="text-secondary">—</span>
      </vs-col>
      <vs-col vs-type="flex" vs-w="1" vs-align="center" vs-justify="center">
        <span :class="{'text-primary text-smaller' : orderBy == 1}" class="underline bold">
        {{ totalQuantity.toLocaleString() }}
        </span>
      </vs-col>
      <vs-col vs-type="flex" vs-w="2" vs-align="center" vs-justify="center">
        <span :class="{'text-primary text-smaller' : orderBy == 0}" class="underline bold">
          {{ $convertCurrency(totalAmount) }}
        </span>
      </vs-col>
      <vs-col vs-type="flex" vs-w="2" vs-align="center" vs-justify="center">
        <span :class="{'text-primary text-smaller' : orderBy == 2}" class="underline bold">
          {{ $convertCurrency(totalCost) }}
        </span>
      </vs-col>
      <vs-col vs-type="flex" vs-w="2" vs-align="center" vs-justify="center">
        <span :class="{'text-primary text-smaller' : orderBy == 3}" class="underline bold">
          {{ $convertCurrency(totalProfit) }}
        </span>
      </vs-col>
    </vs-row>
  </vs-row>
</template>

<script>
import {getReportTypes} from '@/model/constants/dashboardModels'
import {GetPersonalReportAccordingTo,GetPersonalReportAccordingToForDealer, GetExcelPersonalReportAccordingTo,GetExcelPersonalReportAccordingToForDealer,GetBranchProductSizesReportAccordingToForProduct} from '@/api/Reports'
import BranchProductReportViewer from '../BranchProductReportViewer'
import GiroInfo from '../GiroInfo'
import VariantPopup from '../VariantPopup'
/* eslint-disable */
export default {
  components: {
    BranchProductReportViewer,
    GiroInfo,
    VariantPopup
  },
  props: {
    showBranch: {
      type: Boolean,
      default: true
    },
    reportData: {
      type: Array,
      required: true
    },
    orderBy: {
      type: Number,
      required: true
    },
    stop: {
      type: Boolean,
      required: true
    },
    tableOptions: {
      type: Object,
      required: true
    },
    paymentPositiveTotal: {
      default: null
    }
  },
  data() {
    return {
      filterString: null,
      reportTypes: getReportTypes(),
      selectedProduct: {},
      variantSums: {},
      variantPopup : false
    }
  },
  methods: {
    openVariantPopup(id,accordingId){
      let tableParams = _.cloneDeep(this.tableOptions);
      tableParams.accordingTo = this.reportTypes.find(type => type.id === 2).name
      tableParams.accordingId = accordingId;
      GetBranchProductSizesReportAccordingToForProduct(tableParams,id).then(res => {
        this.variantSums = res.data;
      })
      this.variantPopup = true;
    },
    getExcelPersonalReportAccordingTo(accordingId) {
      let tableParams = _.cloneDeep(this.tableOptions);
      tableParams.accordingTo = this.reportTypes.find(type => type.id === 1).name
      tableParams.accordingId = accordingId;
      if (this.$isRegionalCenterBranch()) {
        GetExcelPersonalReportAccordingToForDealer(tableParams).then(res => {
        if (res && res.status === 200) {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          let now = this.$now.date();
          link.setAttribute('download', 'Ürün Şube Raporu' + now.getDate() + " " + this.$months()[now.getMonth()].name + " " + now.getFullYear() + '.xlsx');
          document.body.appendChild(link);
          link.click();

          this.$vs.notify({
            color: "success",
            title: "Başarılı",
            text: "Excel Export Başarılı !"
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: " Ürün Şube Excel Raporu Getirilemedi !"
          });
        }
      }).catch(() => {
        {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: " Sunucu Bağlantı Hatası !"
          });
        }
      })
      } else {
        GetExcelPersonalReportAccordingTo(tableParams).then(res => {
        if (res && res.status === 200) {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          let now = this.$now.date();
          link.setAttribute('download', 'Ürün Şube Raporu' + now.getDate() + " " + this.$months()[now.getMonth()].name + " " + now.getFullYear() + '.xlsx');
          document.body.appendChild(link);
          link.click();

          this.$vs.notify({
            color: "success",
            title: "Başarılı",
            text: "Excel Export Başarılı !"
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: " Ürün Şube Excel Raporu Getirilemedi !"
          });
        }
      }).catch(() => {
        {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: " Sunucu Bağlantı Hatası !"
          });
        }
      })
      }
      
    },
    getPersonalReportAccordingTo(according) {
      let tableParams = _.cloneDeep(this.tableOptions);
      tableParams.accordingTo = this.reportTypes.find(type => type.id === 1).name
      tableParams.accordingId = according.typeId;
      if (this.$isRegionalCenterBranch()) {
        GetPersonalReportAccordingToForDealer(tableParams).then(res => {
        if (res && res.status === 200) {
          this.selectedProduct.list = res.data.list
          this.selectedProduct.variantSums = res.data.variantSums
          if (this.tableOptions.defaultTimeRange) {
            this.selectedProduct.date = this.tableOptions.defaultTimeRange.dName
          } else {
            if (this.tableOptions.dateRange.startDate && this.tableOptions.dateRange.endDate) {
              this.selectedProduct.date = this.tableOptions.dateRange.startDate + ' - ' + this.tableOptions.dateRange.endDate
            } else if (this.tableOptions.dateRange.startDate) {
              this.selectedProduct.date = this.tableOptions.dateRange.startDate + ' ve sonrası'
            } else {
              this.selectedProduct.date = this.tableOptions.dateRange.endDate + ' ve öncesi'
            }
          }
          this.selectedProduct.type = this.reportTypes.find(x => x.name === 'Product')
          this.selectedProduct.orderBy = this.tableOptions.reportByProp ? this.tableOptions.reportByProp.id : 0
          if (this.tableOptions.branch) this.selectedProduct.branch = this.tableOptions.branch
          this.selectedProduct.accordingTo = according
          this.$refs.branchProductReportViewer.isActive = true;
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: " Ürün Personel Raporu Getirilemedi !"
          });
        }
      }).catch(() => {
        {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: " Sunucu Bağlantı Hatası !"
          });
        }
      })
      } else {
        GetPersonalReportAccordingTo(tableParams).then(res => {
        if (res && res.status === 200) {
          this.selectedProduct.list = res.data.list
          this.selectedProduct.variantSums = res.data.variantSums
          if (this.tableOptions.defaultTimeRange) {
            this.selectedProduct.date = this.tableOptions.defaultTimeRange.dName
          } else {
            if (this.tableOptions.dateRange.startDate && this.tableOptions.dateRange.endDate) {
              this.selectedProduct.date = this.tableOptions.dateRange.startDate + ' - ' + this.tableOptions.dateRange.endDate
            } else if (this.tableOptions.dateRange.startDate) {
              this.selectedProduct.date = this.tableOptions.dateRange.startDate + ' ve sonrası'
            } else {
              this.selectedProduct.date = this.tableOptions.dateRange.endDate + ' ve öncesi'
            }
          }
          this.selectedProduct.type = this.reportTypes.find(x => x.name === 'Product')
          this.selectedProduct.orderBy = this.tableOptions.reportByProp ? this.tableOptions.reportByProp.id : 0
          if (this.tableOptions.branch) this.selectedProduct.branch = this.tableOptions.branch
          this.selectedProduct.accordingTo = according
          this.$refs.branchProductReportViewer.isActive = true;
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: " Ürün Personel Raporu Getirilemedi !"
          });
        }
      }).catch(() => {
        {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: " Sunucu Bağlantı Hatası !"
          });
        }
      })
      }
     
    },
    getImage(image) {
      if (!image) return this.$nullImage;
      else return this.$baseUrl + '/' + image;
    },
    openDetailPage() {
      this.$router.push('/pages/reports/product-report').catch(() => {
      })
    }
  },
  computed: {
    /** Tüm satırlar (Kampanya dahil); prop dizisi mutate edilmez. */
    allReportRows() {
      return Array.isArray(this.reportData) ? this.reportData : [];
    },
    totalQuantity() {
      return this.allReportRows.reduce((t, x) => t + (Number(x.piece) || 0), 0);
    },
    totalAmount() {
      return this.allReportRows.reduce((t, x) => t + (Number(x.amount) || 0), 0);
    },
    totalCost() {
      return this.allReportRows.reduce((t, x) => t + (Number(x.cost) || 0), 0);
    },
    totalProfit() {
      return this.allReportRows.reduce((t, x) => t + (Number(x.profit) || 0), 0);
    },
    filteredList() {
      const list = this.allReportRows;
      if (!this.filterString) return list;
      const q = this.filterString.toLowerCase();
      return list.filter(x => x.typeValue && x.typeValue.toLowerCase().includes(q));
    },
    secondProd() {
      if (!this.reportData) return {}
      return this.reportData[1];
    },
    firstProd() {
      if (!this.reportData) return {}
      return this.reportData[0];
    },
    thirdProd() {
      if (!this.reportData) return {}
      return this.reportData[2];
    }
  },
}

</script>

<style>
#productReportThird,
#productReportSecond {
  padding-top: 2.5rem;
}

</style>
